import { createContext, useContext, useEffect, useState } from "react";
import { SITE } from "@/data/content";

const API = process.env.REACT_APP_BACKEND_URL;
const YouTubeContext = createContext({ videos: [], channel: null, loading: true, latestUrl: SITE.youtube });

export const YouTubeProvider = ({ children }) => {
  const [videos, setVideos] = useState([]);
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [feedRes, channelRes] = await Promise.all([
          fetch(`${API}/api/youtube/latest?limit=8`),
          fetch(`${API}/api/youtube/channel`),
        ]);
        if (feedRes.ok) setVideos((await feedRes.json()).videos);
        if (channelRes.ok) setChannel(await channelRes.json());
      } catch (err) {
        console.warn("YouTube feed unavailable, using curated videos", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const latestUrl = videos[0]?.url || SITE.youtube;
  return <YouTubeContext.Provider value={{ videos, channel, loading, latestUrl }}>{children}</YouTubeContext.Provider>;
};

export const useYouTube = () => useContext(YouTubeContext);
